export const padreTypes = {
    PADRE_SAVE_START: '[Padre] SAVE_START',
    PADRE_SAVE_COMPLETE: '[Padre] SAVE_COMPLETE',
    PADRE_SAVE_ERROR: '[Padre] SAVE_ERROR',
    PADRE_VALIDATED: '[Padre] VALIDATED',
    PADRE_UPDATED: '[Padre] UPDATED',
}